import axios from "axios";

const baseReq = axios.create({
  baseURL: "",
  timeout: 5000
});

export const getUser = () => {
  return baseReq.get("/v2/users/get-info").then(res => res.data);
};
